// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speakers[data-v-ab1f3f48] {
  max-width: 540px;
  border-top: 1px solid var(--border-bottom-section);
  padding-top: 12px;
  padding-bottom: 12px;
}
.speakers .speakers-header[data-v-ab1f3f48] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 15px;
}
.speakers .speakers-header span[data-v-ab1f3f48] {
  font-size: 16px;
  font-weight: 600;
  width: 58%;
}
.speakers .speakers-header .custom-select-wrapper[data-v-ab1f3f48] {
  max-width: 300px;
}
.speakers .speakers-level[data-v-ab1f3f48] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.speakers .speakers-level-check[data-v-ab1f3f48] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.speakers .linkBtn[data-v-ab1f3f48] {
  color: var(--base-blue-color2);
  cursor: pointer;
}
.speakers .speakers-visualizer[data-v-ab1f3f48] {
  display: flex;
  justify-content: space-between;
  padding-left: 2px;
}
.speakers .speakers-visualizer .speakers-visualizer-elem[data-v-ab1f3f48] {
  margin-right: 5px;
  height: 10px;
  width: 25px;
  background-color: var(--progress-bg);
  border-radius: 10px;
}
.speakers .speakers-visualizer .speakers-visualizer-elem .speakers-visualizer-elem-active[data-v-ab1f3f48] {
  height: 100%;
  width: 100%;
  background-color: #4DD965;
  border-radius: 10px;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] {
  justify-content: center;
  flex: 1 1 10px;
  display: flex;
  height: 54px;
}
.speakers .speakers-range-slider > *[data-v-ab1f3f48] {
  margin: auto 0;
}
.speakers .speakers-range-slider i[data-v-ab1f3f48] {
  font-size: 16px;
  color: #aaa;
}
.speakers .speakers-range-slider .slider[data-v-ab1f3f48] {
  flex: 1;
  margin: auto 12px;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] range-slider {
  display: inline-block;
  padding: 0 10px;
  height: 5px;
  width: 130px;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider.disabled {
  opacity: 0.5;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-inner {
  display: inline-block;
  position: relative;
  height: 100%;
  width: 100%;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-rail,
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-fill {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  height: 2px;
  border-radius: 5px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-rail {
  width: 100%;
  background-color: #e2e2e2;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-fill {
  background-color: var(--base-blue-color2);
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #aaa;
  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-knob div {
  margin-top: -22px;
  text-align: center;
}
.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-hidden {
  display: none;
}
.speakers[data-v-ab1f3f48] .speaker-select .selected {
  overflow: hidden;
}
.speakers .media-settings-column-1[data-v-ab1f3f48] {
  margin-right: auto;
}
.speakers .media-settings-column-2[data-v-ab1f3f48] {
  width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: row;
}
@media (max-width: 600px) {
.speakers .media-settings-column-2[data-v-ab1f3f48] {
    width: 200px;
    max-width: 200px;
}
.speakers .speakers-visualizer .speakers-visualizer-elem[data-v-ab1f3f48] {
    height: 8px;
    width: calc(200px / 10 - 5px);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/settings/SpeakersSettings.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,sCAAsC;EACtC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA","sourcesContent":[".speakers[data-v-ab1f3f48] {\n  max-width: 540px;\n  border-top: 1px solid var(--border-bottom-section);\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.speakers .speakers-header[data-v-ab1f3f48] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 15px;\n}\n.speakers .speakers-header span[data-v-ab1f3f48] {\n  font-size: 16px;\n  font-weight: 600;\n  width: 58%;\n}\n.speakers .speakers-header .custom-select-wrapper[data-v-ab1f3f48] {\n  max-width: 300px;\n}\n.speakers .speakers-level[data-v-ab1f3f48] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 15px;\n}\n.speakers .speakers-level-check[data-v-ab1f3f48] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 15px;\n}\n.speakers .linkBtn[data-v-ab1f3f48] {\n  color: var(--base-blue-color2);\n  cursor: pointer;\n}\n.speakers .speakers-visualizer[data-v-ab1f3f48] {\n  display: flex;\n  justify-content: space-between;\n  padding-left: 2px;\n}\n.speakers .speakers-visualizer .speakers-visualizer-elem[data-v-ab1f3f48] {\n  margin-right: 5px;\n  height: 10px;\n  width: 25px;\n  background-color: var(--progress-bg);\n  border-radius: 10px;\n}\n.speakers .speakers-visualizer .speakers-visualizer-elem .speakers-visualizer-elem-active[data-v-ab1f3f48] {\n  height: 100%;\n  width: 100%;\n  background-color: #4DD965;\n  border-radius: 10px;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] {\n  justify-content: center;\n  flex: 1 1 10px;\n  display: flex;\n  height: 54px;\n}\n.speakers .speakers-range-slider > *[data-v-ab1f3f48] {\n  margin: auto 0;\n}\n.speakers .speakers-range-slider i[data-v-ab1f3f48] {\n  font-size: 16px;\n  color: #aaa;\n}\n.speakers .speakers-range-slider .slider[data-v-ab1f3f48] {\n  flex: 1;\n  margin: auto 12px;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] range-slider {\n  display: inline-block;\n  padding: 0 10px;\n  height: 5px;\n  width: 130px;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider.disabled {\n  opacity: 0.5;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-inner {\n  display: inline-block;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-rail,\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-fill {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 2px;\n  border-radius: 5px;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-rail {\n  width: 100%;\n  background-color: #e2e2e2;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-fill {\n  background-color: var(--base-blue-color2);\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-knob {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: #aaa;\n  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-knob div {\n  margin-top: -22px;\n  text-align: center;\n}\n.speakers .speakers-range-slider[data-v-ab1f3f48] .range-slider-hidden {\n  display: none;\n}\n.speakers[data-v-ab1f3f48] .speaker-select .selected {\n  overflow: hidden;\n}\n.speakers .media-settings-column-1[data-v-ab1f3f48] {\n  margin-right: auto;\n}\n.speakers .media-settings-column-2[data-v-ab1f3f48] {\n  width: 300px;\n  max-width: 300px;\n  display: flex;\n  flex-direction: row;\n}\n@media (max-width: 600px) {\n.speakers .media-settings-column-2[data-v-ab1f3f48] {\n    width: 200px;\n    max-width: 200px;\n}\n.speakers .speakers-visualizer .speakers-visualizer-elem[data-v-ab1f3f48] {\n    height: 8px;\n    width: calc(200px / 10 - 5px);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
